export default class TestingFrameworkItemModel {
    constructor(
        public name: string, 
        public url: string, 
        public CIIDShow: boolean = true,
        public isChecked: boolean = false,
        public CIID: string = "",
    ) { } 
}